import { useContext } from 'react';
import { DocumentationTokenContext } from '../contexts/documentation-token';
import { DocumentationTokenContextState } from '../types';

export function useDocumentationToken(): DocumentationTokenContextState {
  const context = useContext(DocumentationTokenContext);

  if (context === undefined) {
    throw new Error(
      'useDocumentationToken must be used within a DocumentationTokenProvider'
    );
  }

  return context;
}

/**
 * The value of the token selected in the documentation token selector, or null
 * if none is selected or this isn't inside a DocumentationTokenProvider
 */
export function useSelectedDocumentationToken(): string | null {
  const context = useContext(DocumentationTokenContext);

  return (
    context?.tokens.find(token => token.id === context.selected)?.token ?? null
  );
}
